module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_photowedding_03-918b0254a4b6519dfa09e78eaa5da5a2.webp";